module.exports = __webpack_public_path__ + "static/media/gif1.6b5eb223.gif";